export const SimilarSearchEnum = {
  OBSERVABLE_ENTITY: {
    value: "OBSERVABLE_ENTITY",
    description: 'Observable entity',
    color: 'rgb(230, 230, 255)',
  },
  PROCEDURE: {
    value: "PROCEDURE",
    description: 'Procedure (procedure)',
    color: 'rgb(230, 255, 230)',
  },
  CLINICAL_FINDING: {
    value: "CLINICAL_FINDING",
    description: 'Clinical finding',
    color: 'rgb(255, 230, 230)',
  },
  EVENT: {
    value: "EVENT",
    description: 'Event',
    color: 'rgb(255, 255, 230)',
  },
}; 